import Btn from '@components/Btn';
import { useDispatch, useSelector } from 'react-redux';
import restartProspectus from '@actions/restartProspectus';
import { useRouter } from 'next/router';
import { useI18n } from '@lib/i18n';

import { HEADER_START_OVER_LABEL, VERSION_LITE, WALLED_GARDEN } from '@lib/constants';
import { useEffect, useState } from 'react';

export default function StartOver({ classes, toggleMenuState = false, isAdvisorView = true }) {
	const { t } = useI18n();

	const dispatch = useDispatch();
	const router = useRouter();

	const [isCurrentUserProspectus, setCurrentUserProspectus] = useState(false);
	const [isSavedRestart, setIsSavedRestart] = useState(false);

	const { prospectusId, authenticated } = useSelector((state) => state.user);

	useEffect(() => {
		const currentProspectus = window.location.pathname.split('/').pop();

		setCurrentUserProspectus(prospectusId === currentProspectus);
		setIsSavedRestart(router.pathname === '/prospectus/[slug]');
	}, [authenticated]);

	const hideHeaderButtonsForViews = [
		'/auth/login',
		'/auth/register',
		'/auth/personalise',
		'/advisor',
		'/personalise',
		'/everything',
		'/share',
		'/',
	];

	if (hideHeaderButtonsForViews.includes(router.pathname)) {
		return;
	}

	if (VERSION_LITE) {
		return;
	}

	// We cant start over if we are authenticated, its a saved prospectus and its not my prospectus
	if (authenticated && !isCurrentUserProspectus && isSavedRestart) {
		return;
	}

	const startOver = () => {
		if (toggleMenuState) {
			toggleMenuState(false);
		}

		dispatch(restartProspectus(isSavedRestart));
	};

	if (isSavedRestart && !authenticated) {
		return;
	}

	if (isAdvisorView) {
		return;
	}

	return (
		<Btn
			customClass={classes}
			onClick={() => {
				startOver();
			}}
		>
			<svg preserveAspectRatio="none" viewBox="0 0 24 24" width="24" height="24">
				<g>
					<path
						fill="currentColor"
						d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
						vectorEffect="non-scaling-stroke"
					/>
				</g>
			</svg>
			<span>{t('header.start_over', HEADER_START_OVER_LABEL)}</span>
			<span className="is-sr-only">, create your personalised prospectus from scratch.</span>
		</Btn>
	);
}
